import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SearchComponent} from './search.component';


export const searchRoutes: Routes = [
  {
    path: 'search',
    component: SearchComponent,
    data: {
      'expectedRoles': ['Accountant', 'Accountant Admin']
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(searchRoutes)],
  exports: [RouterModule]
})
export class SearchRoutingModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/search/search-routing.module.ts